import { render, staticRenderFns } from "./vradio.vue?vue&type=template&id=3080ce16&scoped=true"
import script from "./vradio.vue?vue&type=script&lang=js"
export * from "./vradio.vue?vue&type=script&lang=js"
import style0 from "./vradio.vue?vue&type=style&index=0&id=3080ce16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080ce16",
  null
  
)

export default component.exports